import { combineReducers } from 'redux';
import metaData from './reducers/metaData';
import workFlowRule from './reducers/rule';
import workFlowCriteria from './reducers/criteria';
import WorkFlowTrigger from './reducers/trigger';
import { workflowList, workflowLogs } from '../../WorkflowList/flow/reducer';

export default combineReducers({
  metaData,
  workFlowRule,
  workFlowCriteria,
  WorkFlowTrigger,
  workflowList,
  workflowLogs
});



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/flow/reducer.js